import React from 'react'
import FontAwesomeContainer from '../../../Components/Icons/FontAwesome'

export default function FontAwesome() {
    return (
        <div className='page-body'>
            <FontAwesomeContainer />
        </div>
    )
}
